<template>
  <div>
    <!--begin::Content header-->

    <!--begin::Signin-->
    <div class="login-form login-signin">

      <Alert />

      <div class="text-center mb-0">
        <h3 class="font-size-h1">Войти</h3>
      </div>

      <!--begin::Form-->
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div role="alert" class="alert alert-info">
          <div class="alert-text">
            Введите свой логин и пароль
          </div>
        </div>

        <div
          role="alert"
          v-bind:class="{ show: error }"
          class="alert fade alert-danger"
        >
          <div class="alert-text">
            {{ error }}
          </div>
        </div>

        <b-form-group
          id="example-input-group-1"
          label="Логин"
          label-for="example-input-1"
        >
          <b-form-input
            class="form-control form-control-solid h-auto py-5 px-6"
            id="example-input-1"
            name="example-input-1"
            v-model="$v.form.email.$model"
            :state="validateState('email')"
            aria-describedby="input-1-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">
            Требуется электронная почта
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="example-input-group-2"
          label="Пароль"
          label-for="example-input-2"
        >
          <b-form-input
            class="form-control form-control-solid h-auto py-5 px-6"
            type="password"
            id="example-input-2"
            name="example-input-2"
            v-model="$v.form.password.$model"
            :state="validateState('password')"
            aria-describedby="input-2-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-2-live-feedback">
            Требуется пароль
          </b-form-invalid-feedback>
        </b-form-group>

        <!--begin::Action-->
        <div
          class="form-group d-flex flex-wrap justify-content-between align-items-center"
        >
          <button
            ref="kt_login_signin_submit"
            class="btn btn-primary font-weight-bold px-9 py-4 my-3 font-size-3"
          >
            Войти
          </button>
        </div>
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    </div>
    <!--end::Signin-->
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
  import { mapGetters } from "vuex";
import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";
  import Alert from "../../layout/alert/Alert";

import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";
import {SET_ALERT} from "../../../core/services/store/alert.module";
  import {VERIFY_AUTH} from "../../../core/services/store/auth.module";

export default {
  mixins: [validationMixin],
  name: "login",

  components: {
    Alert
  },

  data() {
    return {
      // Remove this dummy login info
      form: {
        email: "",
        password: ""
      }
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(3)
      }
    }
  },
  methods: {
    showAlert(text, variant, type) {
      this.$store.commit(SET_ALERT, {text, variant, type});
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null,
        password: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.$v.form.email.$model;
      const password = this.$v.form.password.$model;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      this.$store.dispatch(LOGIN, { email, password })
            .then(() => {
              this.$store.dispatch(VERIFY_AUTH)
              .then(() => {
                this.$router.push({ name: "dashboard" })
              })
              .catch((response) => {
                this.showAlert(response.data.message, 'danger', 'toast');
              })

            })
            .catch((response) => {
                  this.showAlert(response.data.message, 'danger', 'toast');
                })

            .finally(() => {
          submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
        });
    }
  },
  computed: {
    ...mapGetters({
      error: 'errorsMessageUser'
    })
  }
};
</script>
